import React from 'react';
import PropTypes from 'prop-types';
import autobind from 'core-decorators/lib/autobind';
import Select from '@wix/wix-vod-shared/src/widget/ui-components/select/select';
import styles from './embed-styles.styl';


class EmbedSelect extends React.Component {

  static propTypes = {
    dataHook: PropTypes.string,
    ariaLabel: PropTypes.string,
    selected: PropTypes.string,
    options: PropTypes.array,
    onChange: PropTypes.func,
  };

  @autobind
  handleChange(e) {
    this.props.onChange(e.target.value);
  }

  render() {
    const { options, selected, dataHook, ariaLabel } = this.props;
    return (
      <Select dataHook={dataHook}
              ariaLabel={ariaLabel}
              className={styles.select}
              selected={selected}
              onChange={this.handleChange}
              options={options} />
    );
  }
}

export default EmbedSelect;



// WEBPACK FOOTER //
// ./src/widget/containers/share-overlay/embed-form/embed-select/embed-select.js